import { formatDuration, formatKm } from '@shared/format';
import { asset } from '../site/assets';
import styles from './Figures.module.css';

interface Props {
    distance: number;
    /** Hours. */
    duration: number;
    up: number;
    down: number;
    size?: 'md' | 'sm';
}

/** Distance / duration / D+ / D- row (2 × 2 on phones, 4 columns otherwise). */
export function Figures({ distance, duration, up, down, size = 'md' }: Props) {
    const icon = size === 'md' ? 20 : 15;
    return (
        <div className={`${styles.figures} ${size === 'sm' ? styles.small : ''}`}>
            <div className={styles.distance}>
                <img src={asset('/assets/icons/distance-gris.svg')} height={icon} alt="Distance" />
                <b>{formatKm(distance)}</b>
            </div>
            <div className={styles.duration}>
                <img src={asset('/assets/icons/marche-gris.svg')} height={icon} alt="Durée" />
                <b>~{formatDuration(duration)}</b>
            </div>
            <div className={styles.up}>
                <img src={asset('/assets/d-plus.svg')} width={icon + 5} alt="Dénivelé positif" />
                <span>{up} m D+</span>
            </div>
            <div className={styles.down}>
                <img src={asset('/assets/d-minus.svg')} width={icon + 5} alt="Dénivelé négatif" />
                <span>{down} m D-</span>
            </div>
        </div>
    );
}
